import constants from '../constants';

export const setRoutes = (routes: React.Component[]) => ({
  type: constants.SET_ROUTES,
  payload: routes,
});

export const changeRoute = (path: string) => ({
  type: constants.CHANGE_ROUTE,
  payload: path,
});
